/* Skiltsøk — snippets/skiltsok.liquid.
   Sender skiltnummeret til Edge Function-en skiltsok (Statens vegvesen) og viser
   sykkelen, dekkene foran og bak med lenke til dekksøket, og treff i delekatalogen
   med lenke til sykkelsøket. Skiltnummeret lagres ikke, verken her eller hos oss. */
(function () {
  if (window.__mcsSkiltsok) return;
  window.__mcsSkiltsok = true;

  const esc = (t) => String(t == null ? '' : t)
    .replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // Kjedesett-veiviseren tar sykkelen fra url-en, som sykkelsøket.
  function sykkelUrl(k, sted) {
    const side = sted === 'kjedekit' ? '/pages/kjedesett' : '/pages/sykkelsok';
    return side + '?' + new URLSearchParams({ merke: k.merke, modell: k.modell, aar: k.aar }).toString();
  }

  const LI = 'filter.v.m.custom.lastindeks.gte';
  const KMH = 'filter.v.m.custom.hastighet_kmh.gte';
  const SYMBOL = { 50: 'B', 60: 'C', 65: 'D', 70: 'E', 80: 'F', 90: 'G', 100: 'J', 110: 'K', 120: 'L', 130: 'M',
    140: 'N', 150: 'P', 160: 'Q', 170: 'R', 180: 'S', 190: 'T', 200: 'U', 210: 'H', 240: 'V', 270: 'W', 300: 'Y' };

  // Dimensjonen, og minst like høy last- og hastighetsindeks som vognkortet krever.
  // Indeksfiltrene vises ikke i sidepanelet; de settes bare herfra.
  function dekkUrl(f, krav) {
    const p = new URLSearchParams();
    p.append('filter.v.m.custom.dekkbredde', f.bredde);
    if (f.profil) p.append('filter.v.m.custom.profil', f.profil);
    p.append('filter.v.m.custom.felgdiameter', f.felg);
    if (krav && krav.lastindeks) p.append(LI, krav.lastindeks);
    if (krav && krav.hastighet_kmh) p.append(KMH, krav.hastighet_kmh);
    return '/collections/tires?' + p.toString();
  }

  function kravTekst(krav) {
    if (!krav) return '';
    const deler = [];
    if (krav.lastindeks) deler.push('lastindeks ' + krav.lastindeks);
    if (krav.hastighet_kmh) deler.push((krav.hastighetsindeks || SYMBOL[krav.hastighet_kmh] || '') + ' (' + krav.hastighet_kmh + ' km/t)');
    return deler.length ? 'minst ' + deler.join(' og ') : '';
  }

  // Kandidat uten år fra søket: registreringsåret innenfor modellens årsspenn.
  function aarFor(k, regAar) {
    if (k.aar) return k.aar;
    const fra = Number(k.aar_fra) || null, til = Number(k.aar_til) || null;
    if (regAar && fra && til) return Math.min(Math.max(regAar, fra), til);
    return til || fra || regAar;
  }

  function dekkLinje(navn, d) {
    if (!d || !d.dimensjon) return '';
    const idx = [d.lastindeks, d.hastighetsindeks].filter(Boolean).join('');
    const krav = d.krav;
    const merke = idx
      ? `<span class="sk__idx" title="Lastindeks og hastighetsindeks fra vognkortet">${esc(idx)}</span>`
      : (krav ? `<span class="sk__idx" title="Beregnet ut fra tillatt vekt og toppfart">${esc(kravTekst(krav))}, beregnet</span>` : '');
    const lenke = d.filter ? `<a href="${esc(dekkUrl(d.filter, krav))}">Se dekk ${navn.toLowerCase()} &rarr;</a>` : '';
    return `<li><span class="sk__akse">${navn}</span><strong>${esc(d.dimensjon)}</strong>${merke}${lenke}</li>`;
  }

  function tegnSvar(rot, d) {
    const sted = rot.dataset.sted;
    const k = d.kjoretoy || {};
    const navn = [k.merke, k.modell].filter(Boolean).join(' ');
    const deler = [];
    if (k.aar) deler.push('første gang registrert ' + k.aar);
    if (k.ccm) deler.push(k.ccm + ' cm³');
    const funn = `<p class="sk__funn">&#10003; <strong>${esc(navn || 'Kjøretøyet')}</strong>${deler.length ? ' · ' + esc(deler.join(' · ')) : ''}</p>`;

    const dekk = (sted !== 'kjedekit' && (k.foran || k.bak))
      ? `<ul class="sk__dekk">${dekkLinje('Foran', k.foran)}${dekkLinje('Bak', k.bak)}</ul>` +
        '<p class="sk__merk">Vi viser bare dekk med riktig dimensjon og minst like høy last- og hastighetsindeks som vognkortet krever.' +
        ((k.foran && k.foran.krav && k.foran.krav.beregnet) || (k.bak && k.bak.krav && k.bak.krav.beregnet)
          ? ' Der vognkortet ikke oppgir indeks, har vi regnet den ut fra tillatt vekt og toppfart.' : '') +
        ' Sjekk likevel selv før montering.</p>'
      : '';

    const liste = (d.kandidater || []).map((c) => ({ ...c, aar: aarFor(c, k.aar) })).filter((c) => c.aar);
    let valg;
    if (liste.length) {
      const [forste, ...andre] = liste;
      const tekst = sted === 'kjedekit' ? 'Finn kjedesett for' : 'Vis deler for';
      valg = `<a class="sk__hoved" href="${esc(sykkelUrl(forste, sted))}">${tekst} ${esc(forste.merkenavn || forste.merke)} ${esc(forste.modell)} ${esc(forste.aar)} &rarr;</a>`;
      if (andre.length) {
        valg += '<p class="sk__andre">Er det en av disse? ' + andre.map((c) =>
          `<a href="${esc(sykkelUrl(c, sted))}">${esc(c.modell)} ${esc(c.aar)}</a>`).join('') + '</p>';
      }
    } else {
      valg = '<p class="sk__merk">Vi fant ikke modellen i delekatalogen. Søk på modell, eller <a href="/pages/kontakt">spør oss</a>.</p>';
    }

    const svarBoks = rot.querySelector('[data-svar]');
    svarBoks.innerHTML = rot.dataset.sted === 'dekk' ? funn + dekk + valg : funn + valg + dekk;
    svarBoks.hidden = false;
  }

  function tegnFeil(rot, tekst) {
    const svarBoks = rot.querySelector('[data-svar]');
    svarBoks.innerHTML = `<p class="sk__feil">${esc(tekst)}</p>`;
    svarBoks.hidden = false;
  }

  async function sok(rot, skilt) {
    const knapp = rot.querySelector('.sk__knapp');
    knapp.disabled = true;
    const svarBoks = rot.querySelector('[data-svar]');
    svarBoks.hidden = false;
    svarBoks.innerHTML = '<p>Slår opp hos Statens vegvesen …</p>';
    try {
      const r = await fetch(rot.dataset.api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kjennemerke: skilt }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) {
        tegnFeil(rot, d.melding || 'Skiltsøket virker ikke akkurat nå. Søk på modell i stedet.');
      } else if (!d.funnet) {
        tegnFeil(rot, 'Fant ikke noe kjøretøy med det skiltnummeret. Sjekk at det er skrevet riktig.');
      } else {
        tegnSvar(rot, d);
      }
    } catch (e) {
      tegnFeil(rot, 'Fikk ikke kontakt med skiltsøket. Prøv igjen, eller søk på modell.');
    } finally {
      knapp.disabled = false;
    }
  }

  // På dekksiden: vis kravet som er satt fra skiltsøket, med lenke for å se alle dekk
  // i dimensjonen (indeksfiltrene ligger ikke i sidepanelet).
  function visAktivtKrav(rot) {
    const p = new URLSearchParams(location.search);
    const li = p.get(LI), kmh = p.get(KMH);
    if (!li && !kmh) return;
    const tekst = kravTekst({ lastindeks: li, hastighet_kmh: kmh ? Number(kmh) : null });
    p.delete(LI); p.delete(KMH);
    const alle = location.pathname + (p.toString() ? '?' + p.toString() : '');
    const boks = document.createElement('p');
    boks.className = 'sk__aktiv';
    boks.innerHTML = `Viser dekk med ${esc(tekst)}, etter vognkortet. <a href="${esc(alle)}">Vis alle dekk i dimensjonen</a>`;
    rot.insertBefore(boks, rot.firstChild);
  }

  function start() {
    document.querySelectorAll('[data-skiltsok]').forEach((rot) => {
      if (rot.dataset.sted === 'dekk') visAktivtKrav(rot);
      const skjema = rot.querySelector('form');
      const felt = rot.querySelector('[data-skilt]');
      skjema.addEventListener('submit', (e) => {
        e.preventDefault();
        const skilt = felt.value.toUpperCase().replace(/[\s-]/g, '');
        if (!/^[A-ZÆØÅ0-9]{2,7}$/.test(skilt)) {
          tegnFeil(rot, 'Skriv skiltnummeret, for eksempel AB 12345.');
          felt.focus();
          return;
        }
        sok(rot, skilt);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();